import { render, staticRenderFns } from "./EmailGroupEditor.vue?vue&type=template&id=ce1adada&scoped=true&"
import script from "./EmailGroupEditor.vue?vue&type=script&lang=js&"
export * from "./EmailGroupEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailGroupEditor.vue?vue&type=style&index=0&id=ce1adada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1adada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce1adada')) {
      api.createRecord('ce1adada', component.options)
    } else {
      api.reload('ce1adada', component.options)
    }
    module.hot.accept("./EmailGroupEditor.vue?vue&type=template&id=ce1adada&scoped=true&", function () {
      api.rerender('ce1adada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Email/EmailGroupEditor.vue"
export default component.exports